<template>
  <div
    class="modal-page-wrapper"
    @click.self.stop="message && type ? false : $emit('closed')"
    :class="[{ isModal: isModal }]"
  >
    <div class="modal-page-background" v-if="!isModal"></div>
    <div
      class="modal-page"
      :class="[
        { 'border-top-blue': borderTopBlue },
        { 'no-min-height': noMinHeight },
        { 'modal-page-centered': isCentered },
      ]"
      :style="{ width: width, 'max-width': width }"
      @click.self.stop="$emit('closed')"
    >
      <div v-if="isModal" @click.stop="$emit('closed')">
        <div v-if="closeIconNew" class="close-icon-new">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
              width="1.73753"
              height="18.7617"
              rx="0.868766"
              transform="matrix(0.690171 -0.723646 0.685263 0.728296 0.758026 1.25745)"
              fill="#747474"
            />
            <rect
              width="1.73231"
              height="18.7583"
              rx="0.866156"
              transform="matrix(0.68772 0.725976 -0.68772 0.725976 12.9005 0)"
              fill="#747474"
            />
          </svg>
        </div>
        <div v-else class="close-icon">
          <i class="icon icon-times" />
        </div>
      </div>
      <div class="modal-page-header" v-if="title">
        <div class="title">
          <span>{{ title.toUpperCase() }}</span>
        </div>
        <div class="description">{{ description }}</div>
      </div>
      <div class="modal-page-body mt-desktop" :class="{ message: message }">
        <div class="modal-message" v-if="type && message">
          <img src="@/assets/images/icon_check.png" class="modal__icon" v-if="type === 'success'" />
          <svg
            v-if="type === 'error'"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 20C0 8.97193 8.97193 0 20 0C31.0281 0 40 8.97193 40 20C40 31.0281 31.0281 40 20 40C8.97193 40 0 31.0281 0 20Z"
              fill="#ED6706"
            />
            <path
              d="M20 23C20.6196 23 21.1353 22.484 21.1875 21.8129L21.993 11.3559C22.0399 10.7494 21.8507 10.1498 21.472 9.70206C21.0937 9.25484 20.5595 9 20 9C19.4405 9 18.9063 9.25484 18.528 9.70206C18.1492 10.1498 17.9601 10.7494 18.007 11.3559L18.8125 21.8129C18.8647 22.484 19.3804 23 20 23Z"
              fill="white"
            />
            <path
              d="M20 25C18.8953 25 18 25.8952 18 27.0001C18 28.1048 18.8953 29 20 29C21.1047 29 22 28.1048 22 27.0001C22 25.8952 21.1047 25 20 25Z"
              fill="white"
            />
          </svg>
          <span class="message" :class="[{ success: type === 'success' }, { error: type === 'error' }]">
            {{ message }}
          </span>
        </div>
        <slot name="body"> </slot>
      </div>
      <div v-if="$slots.footer" class="modal-page-footer">
        <slot name="footer"> </slot>
      </div>
    </div>
    <div class="bg-dark" v-bind:class="{ open: isModal }" @click.stop="$emit('closed')"></div>
    <template v-if="type && type === 'success' && $route.matched[0] && $route.matched[0].name === 'deposit'">
      <component :is="'script'">
        fbq('track', 'Purchase', {currency: "EUR", value: 0.00});
      </component>
      <!-- Twitter single-event website tag code -->
      <component :is="'script'" src="//platform.twitter.com/oct.js" type="text/javascript"></component>
      <component :is="'script'" type="text/javascript"
        >twttr.conversion.trackPid('o4rwi', { tw_sale_amount: 0, tw_order_quantity: 0 });</component
      >
      <noscript>
        <img
          height="1"
          width="1"
          style="display:none;"
          alt=""
          src="https://analytics.twitter.com/i/adsct?txn_id=o4rwi&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
        />
        <img
          height="1"
          width="1"
          style="display:none;"
          alt=""
          src="//t.co/i/adsct?txn_id=o4rwi&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
        />
      </noscript>
      <!-- End Twitter single-event website tag code -->

      <!-- Twitter single-event website tag code -->
      <component :is="'script'" src="//platform.twitter.com/oct.js" type="text/javascript"></component>
      <component :is="'script'" type="text/javascript"
        >twttr.conversion.trackPid('o4s1z', { tw_sale_amount: 0, tw_order_quantity: 0 });</component
      >
      <noscript>
        <img
          height="1"
          width="1"
          style="display:none;"
          alt=""
          src="https://analytics.twitter.com/i/adsct?txn_id=o4s1z&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
        />
        <img
          height="1"
          width="1"
          style="display:none;"
          alt=""
          src="//t.co/i/adsct?txn_id=o4s1z&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
        />
      </noscript>
      <!-- End Twitter single-event website tag code -->
    </template>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    closeIconNew: {
      type: Boolean,
      default: false,
    },
    borderTopBlue: {
      type: Boolean,
      default: false,
    },
    noMinHeight: {
      type: Boolean,
      default: false,
    },
    isCentered: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import '../../sass/variables';
@import '../../sass/mixins/_mixins';
.modal-page-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);

  @media (min-width: 768px) {
    padding-top: 70px;
    padding-bottom: 70px;
  }
}

.modal-page-centered {
  display: flex;
  align-items: center;
  justify-content: center;
}

.isModal {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh !important;
  padding-top: 4rem;
  padding-bottom: 2rem;
  z-index: 2000;
  overflow-y: auto;
  overflow-x: hidden;
  @media screen and (max-width: 767px) {
    padding: 0 0;
    .modal-page {
      padding: 42px 24px !important;
      min-height: 100vh;
      &.no-min-height {
        min-height: 0 !important;
        margin: 0px 10px 0px 10px;
        padding-bottom: 20px !important;
        padding-right: 10px !important;
        padding-left: 10px !important;
      }
    }
  }

  .modal-page {
    max-width: 500px;
    background: #ffffff;
    position: relative;
    z-index: 101;
  }

  .close-icon {
    cursor: pointer;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    right: -14px;
    top: -14px;
    background: white;
    border: 2px solid #d5d5d5;
    width: 35px;
    height: 35px;
    border-radius: 100%;
    .icon {
      font-size: 16px;
    }
    @media screen and (max-width: 767px) {
      right: 24px;
      top: 8px;
    }
  }
}

.modal-page {
  width: 450px;
  display: flex;
  color: $color-1;
  flex-direction: column;
  background: $pale-grey-two;
  border-radius: 4px;
  box-shadow: 0px 3px 6px #00000029;
  padding: 25px 25px;
  @media (max-width: 767px) {
    padding: 25px 12px;
  }
  &-body {
    &.message {
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
      background: white;
    }
  }
  &-header {
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px !important;
      color: $color-3;
      font-weight: bold;
      span {
        width: 60%;
        text-align: center;
      }
      &:after {
        content: '';
        margin-left: 16px;
        display: inline-block;
        flex: 1;
        width: 60px;
        height: 2px;
        background-color: $color-3;
      }
      &:before {
        content: '';
        margin-right: 16px;
        display: inline-block;
        flex: 1;
        height: 2px;
        background-color: $color-3;
      }
    }
    .description {
      font-size: 16px !important;
      font-weight: bold;
      color: $color-9;
    }
  }
}

.modal-message {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 1rem;
  img {
    width: 42px;
    height: 42px;
  }
  .message {
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    margin-top: 0.75rem;
    &.success {
      color: #343a40;
    }
    &.error {
      color: #343a40;
    }
    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
}

.modal-page-background {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url('../../assets/images/bg-login2.jpg') no-repeat center center;
  z-index: -1;
  background-size: cover;
}

.close-icon-new {
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 13px;
  top: 8px;
  width: 35px;
  height: 35px;
  border-radius: 100%;
  .icon {
    font-size: 16px;
  }
  @media screen and (max-width: 767px) {
    right: 17px;
    top: 8px;
  }
}

.mt-desktop {
  @media (min-width: 767px) {
    margin-top: 0.5rem;
  }
}
</style>
